module.exports = __webpack_public_path__ + "static/Caley-detail-mobile-bf924f929b748dcf8d6e45e36070db7e.png";